export interface SDKConfig {
  sandbox: boolean;
  sandboxPaymentUrl: string;
  productionPaymentUrl: string;
  /** Merchant public key (`pk_...`). Set by `data-client-key` on the script tag, or by `configure()`. */
  publicKey?: string;
}

const DEFAULT_CONFIG: SDKConfig = {
  sandbox: true,
  sandboxPaymentUrl: "https://pay-sandbox.arto-pay.com/arto-pay",
  productionPaymentUrl: "https://pay.arto-pay.com/arto-pay",
};

let currentConfig: SDKConfig = { ...DEFAULT_CONFIG };

export function configure(config: Partial<SDKConfig>): void {
  currentConfig = { ...currentConfig, ...config };
}

export function getConfig(): SDKConfig {
  return currentConfig;
}

export function getPaymentUrl(paymentId: string, sandbox: boolean = currentConfig.sandbox): string {
  const baseUrl = sandbox
    ? currentConfig.sandboxPaymentUrl
    : currentConfig.productionPaymentUrl;

  return `${baseUrl}/${paymentId}`;
}

export function getPublicKey(): string | undefined {
  return currentConfig.publicKey;
}

export function isSandboxMode(): boolean {
  return currentConfig.sandbox;
}
